import { actionTypes } from 'redux/actions/analytics'

type UserVisits = string[]

export type PathUsers = {
  [user: string]: UserVisits
}

export type AnalyticsData = {
  [path: string]: PathUsers
}

export interface IAnalyticsState {
  analyticsData: AnalyticsData | null
  isAnalyticsLoading: boolean
}

export const initialState: IAnalyticsState = {
  analyticsData: null,
  isAnalyticsLoading: false,
}

export const analyticsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SET_ANALYTICS_DATA:
      return {
        ...state,
        analyticsData: action.payload,
      }
    case actionTypes.SET_IS_ANALYTICS_LOADING:
      return {
        ...state,
        isAnalyticsLoading: action.payload,
      }
    default:
      return state
  }
}
